import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { GetUserRole } from '../services/UserRole';
import { Edit } from "@mui/icons-material";
import toast from 'react-hot-toast';
import { Url } from '../services/Constants';
import { setHeader } from '../services/Headers';
import { useNavigate } from 'react-router-dom';
import { setImgHeader } from '../services/Headers';

export default function ProfileTile({ profileData, userAddress, profilepics, updateProfileData }) {

  const Navigate = useNavigate()



  const [error, setError] = useState(null);
  const pincode = useRef()
  const firstname = useRef()
  const lastname = useRef()
  const email = useRef()
  const mobile = useRef()
  const company_name = useRef()
  const office_number = useRef()
  const gst_number = useRef()
  const contact_person = useRef()
  const cell_number = useRef()
  const bank_number = useRef()
  const bank_name = useRef()
  const ifsc_number = useRef()
  const street_address = useRef()


  const [pincodeData, setPincodeData] = useState()



  const [selectedFile, setSelectedFile] = useState(null);
  useEffect(() => {


  })


  const pincodeFinder = async (e) => {
    if (e.target.value.length === 6) {
      try {
        const data = Number(e.target.value);
        const result = await axios.get(`https://api.postalpincode.in/pincode/${data}`);
        if (result.data[0].Status === "Success") {
          const postOffice = result.data[0].PostOffice[0];
          setPincodeData(postOffice);
        } else {
          setPincodeData(null);
          toast.error("Please Enter Correct Pincode");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setPincodeData(null);
    }
  };

  useEffect(() => {

  }, [pincode]);


  const base64ToFile = (base64Data, filename, contentType) => {
    const byteCharacters = atob(base64Data.split(',')[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const byteSlice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(byteSlice.length);

      for (let i = 0; i < byteSlice.length; i++) {
        byteNumbers[i] = byteSlice.charCodeAt(i);
      }

      byteArrays.push(new Uint8Array(byteNumbers));
    }

    const file = new Blob(byteArrays, { type: contentType });
    return new File([file], filename, { type: contentType });
  };

  const submitHandle = async (e) => {
    e.preventDefault()
    let fullname
    if (firstname && firstname.current) {
      fullname = firstname.current.value + " " + lastname.current.value
    }
    if (profileData.role === "buyer") {
      const formData = new FormData();
      formData.append('mobile_code', 91);
      formData.append('mobile_number', mobile.current.value);
      formData.append('name', fullname);
      formData.append('gst_number',gst_number.current.value)
      // formData.append('profile_pic', profilepics);
      // Handle profile pic - either the uploaded file or base64 string

      const profilePic = selectedFile || (profilepics ? base64ToFile(profilepics, 'profile_pic.png', 'image/png') : null);

      if (profilePic) {

        formData.append('profile_pic', profilePic);

      }
      formData.append('email', email.current.value);

      try {
        const result = await axios.put(`${Url}/buyer/profile/update`, formData, setImgHeader());

        if (result.data.response_code === 200) {
          const userAddressData = {
            street_address: street_address.current.value,
            pincode: Number(pincode.current.value),
            city: pincodeData ? pincodeData.District : userAddress?.city,
            state: pincodeData ? pincodeData.State : userAddress?.state
          };
          updateProfileData({
            firstName: firstname.current.value,
            lastName: lastname.current.value,
            email: email.current.value,
            mobile_number: mobile.current.value,
            gst_number:gst_number.current.value,
            // Add other fields as necessary
          });

          if (userAddress) {
            const addressUpdate = await axios.put(`${Url}/buyer/addresses/${userAddress.id}`, userAddressData, setImgHeader());

            if (addressUpdate.data.response_code === 200) {
              toast.success("Profile updated successfully.");
              Navigate("/profile/user");
            } else {
              toast.error("Failed to update address.");
            }
          } else if (pincodeData) {
            const addressUpdate = await axios.post(`${Url}/buyer/addresses`, userAddressData, setImgHeader());

            if (addressUpdate.data.response_code === 200) {
              toast.success("Profile updated successfully.");
              Navigate("/profile/user");
            } else {
              toast.error("Failed to create address.");
            }
          } else {
            toast.success("Profile updated successfully.");
            Navigate("/profile/user");
          }
        } else {
          toast.error("Something went wrong with the profile update!");
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        toast.error("An error occurred while updating the profile.");
      }
    } else if (profileData.role === "seller") {
      const formData = new FormData();
      formData.append('mobile_code', 91);
      formData.append('mobile_number', profileData.mobile_number);
      formData.append('name', fullname);
      // formData.append('profile_pic', profilepics);
      formData.append('email', email.current.value);
      formData.append('cell_number', cell_number.current.value);
      formData.append('company_address', street_address.current.value);
      // formData.append('office_number', office_number.current.value);
      formData.append('contact_person', contact_person.current.value);
      formData.append('gst_number', gst_number.current.value);
      formData.append('state', pincodeData ? pincodeData.State : profileData?.state);
      formData.append('city', pincodeData ? pincodeData.District : profileData?.city);
      formData.append('zip_code', pincode ? Number(pincode.current.value) : profileData?.zip_code);
      formData.append('account_number', bank_number.current.value);
      formData.append('bank_name', bank_name.current.value);
      formData.append('ifsc_number', ifsc_number.current.value);
      // formData.append('company_name', company_name.current.value);


      try {
        const result = await axios.put(`${Url}/seller/profile/update`, formData, setImgHeader())
        if (result.data.response_code === 200) {
          updateProfileData({
            firstName: firstname.current.value,
            lastName: lastname.current.value,
          });
          toast.success("Profile update successfully.")
          Navigate("/profile/seller")
        } else {
          toast.error("Please enter all fields!")
        }
      } catch (error) {
        console.log(error)
      }
    }



  }









  return (
    <div className="about-container  mr-2   max-lg:top-2  ">
      <div className="about-top bg-red-50 p-5 rounded-md shadow-md">
        <div className="title mb-5 border-b">
          <span className="k  w-full text-lg font-bold text-amber-950 py-2">PERSONAL INFORMATION</span>
        </div>
        <div className="information bg-white rounded-md shadow-md p-5">
          
          {profileData?.role === "buyer" ? <div className="buyer ">
            <div className="info-top mb-10 px-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                <input
                  type="text"
                  name="firstName"
                  defaultValue={profileData?.firstName}
                  ref={firstname}
                  placeholder="First Name"
                  className="bg-white border border-gray-300 rounded-md p-3 outline-none w-full"
                />
                <input
                  type="text"
                  name="lastName"
                  defaultValue={profileData?.lastName}
                  ref={lastname}
                  placeholder="Last Name"
                  className="bg-white border border-gray-300 rounded-md p-3 outline-none w-full"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                <div className="w-full">
                  <label className="block text-amber-950 text-lg font-bold mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    defaultValue={profileData?.email}
                    ref={email}
                    placeholder="Email Address"
                    className="bg-white border border-gray-300 rounded-md p-3 outline-none w-full"
                  />
                </div>

                <div className="w-full">
                  <label className="block text-amber-950 text-lg font-bold mb-2">
                    Contact Number
                  </label>
                  <div className="flex items-center">
                    <span className="border border-gray-300 rounded-md px-3 py-2 bg-gray-200">+91</span>
                    <input
                      type="text"
                      name="mobile_number"
                      defaultValue={profileData?.mobile_number}
                      ref={mobile}
                      placeholder="Contact Number"
                      maxLength={10}
                      className="bg-white border border-gray-300 rounded-md p-3 outline-none ml-3 w-full"
                    />
                  </div>
                </div>
              </div>

              <div className="w-full sm:w-1/2">
                <label className="block text-amber-950 text-lg font-bold mb-2">
                  GST Number
                </label>
                <input
                  type="text"
                  name="gst_number"
                  defaultValue={profileData?.gst_number}
                  onInput={(e) => {
                    e.target.value = e.target.value.toUpperCase();
                  }}
                  ref={gst_number}
                  placeholder="GST NUMBER"
                  className="bg-white border border-gray-300 rounded-md p-3 outline-none w-full tracking-wider uppercase"
                />
              </div>
            </div>
            <div className="info-bottom mb-10">
              <div className="title mb-5 border-b">
                <span className="k  w-full text-lg font-bold text-amber-950 py-2">Manage Address</span>
              </div>
              <div className="address mb-5">
                <input
                  type="text"
                  name="state"
                  value={pincodeData ? pincodeData.State : userAddress?.state}
                  //onChange={handleChange}
                  placeholder="State"
                  className="bg-slate-100 border w-[25%] border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  disabled
                />
                <input
                  type="text"
                  name="city"
                  value={pincodeData ? pincodeData.District : userAddress?.city}
                  //   onChange={handleChange}
                  placeholder="City"
                  className="bg-slate-100 border w-[25%] ml-10 border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  disabled
                />
                <input
                  type="text"
                  name="pincode"
                  defaultValue={userAddress?.pincode}
                  ref={pincode}
                  onChange={pincodeFinder}
                  placeholder="Pincode"
                  className="bg-white border w-[25%] border-gray-300 rounded-md ml-10 p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  maxLength={6}
                />
              </div>
              <div className="address">
                <textarea name="" id="" ref={street_address} defaultValue={userAddress?.street_address} className='resize-none bg-white border border-gray-300 rounded-md w-[80%] p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto' placeholder='Address' />
              </div>
            </div>
          </div> :

            //for seller profile

            <div className="seller  ">
              <div className="info-top ">
                <div className="mb-5">
                  <input
                    type="text"
                    name="firstName"
                    defaultValue={profileData?.firstName}
                    ref={firstname}
                    //   onChange={handleChange}
                    placeholder="First Name"
                    className="bg-white border w-[25%] border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto "
                  />
                  <input
                    type="text"
                    name="lastName"
                    ref={lastname}
                    defaultValue={profileData?.lastName}
                    //   onChange={handleChange}
                    placeholder="Last Name"
                    className="bg-white border w-[25%] ml-10 border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  />
                </div>
                <div className="address mb-5">
                  <input
                    type="text"
                    name="state"
                    value={pincodeData ? pincodeData.State : profileData?.state}
                    //   onChange={handleChange}
                    placeholder="State"
                    className="bg-slate-100 border w-[25%] border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                    disabled
                  />
                  <input
                    type="text"
                    name="city"
                    value={pincodeData ? pincodeData.District : profileData?.city}
                    //   onChange={handleChange}
                    placeholder="City"
                    className="bg-slate-100 border w-[25%] ml-10 border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                    disabled
                  />
                  <input
                    type="text"
                    name="pincode"
                    defaultValue={profileData?.zip_code}
                    ref={pincode}
                    onChange={pincodeFinder}
                    placeholder="Pincode"
                    className="bg-white border w-[25%] border-gray-300 rounded-md ml-10 p-2 outline-none max-sm:block max-sm:w-[90%] max-sm:mx-auto"
                    maxLength={6}
                  />
                </div>
                <div className="mb-5">
                  <input
                    type="text"
                    name="Gst"
                    ref={gst_number}
                    defaultValue={profileData?.gst_number}
                    placeholder=" GST"
                    className="bg-white border w-[25%] border-gray-200 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  />
                  <input
                    type="text"
                    name="Contact Person"
                    ref={contact_person}
                    defaultValue={profileData?.contact_person}
                    //   onChange={handleChange}
                    placeholder="Contact Person"
                    className="bg-white border w-[25%] ml-10 border-gray-300 rounded-md p-2 outline-none max-sm:block  max-sm:w-[90%] max-sm:mx-auto"
                  />
                </div>
                <div className="mb-5">
                  <input
                    type="email"
                    name="email"
                    ref={email}
                    defaultValue={profileData?.email}
                    //   onChange={handleChange}
                    placeholder=" Email Id"
                    className="bg-white border w-[25%] border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  />
                  <input
                    type="text"
                    name="Cell number"
                    ref={cell_number}
                    defaultValue={profileData?.cell_number}
                    //   onChange={handleChange}
                    placeholder="Cell Number"
                    className="bg-white border w-[25%] ml-10 border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:w-[90%] max-sm:mx-auto"
                  />
                </div>
                <div className="address">
                  <textarea name="" id="" ref={street_address} defaultValue={profileData?.company_address} className='resize-none bg-white border border-gray-300 rounded-md w-[81%] p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto' placeholder='Address' />
                </div>
              </div>
              <div className="bank">
                <span className="k block text-lg font-bold text-amber-950 py-2 ">Bank Details</span>
                <div className="mb-5">
                  <input
                    type="text"
                    name="account-number"
                    ref={bank_number}
                    defaultValue={profileData?.bank_number}
                    //   onChange={handleChange}
                    placeholder="Bank Name"
                    className="bg-white border w-[25%] border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  />
                  <input
                    type="text"
                    name="bank-name"
                    ref={bank_name}
                    defaultValue={profileData?.bank_name}
                    //   onChange={handleChange}
                    placeholder="Account No"
                    className="bg-white border w-[25%] ml-10 border-gray-300 rounded-md p-2 outline-none max-sm:block  max-sm:w-[90%] max-sm:mx-auto"
                  />
                </div>
                <div className="mb-5">
                  <input
                    type="text"
                    name="IFSC"
                    ref={ifsc_number}
                    defaultValue={profileData?.ifsc_number}
                    //   onChange={handleChange}
                    placeholder="IFSC no"
                    className="bg-white border w-[25%] border-gray-300 rounded-md p-2 outline-none max-sm:block max-sm:mb-5 max-sm:w-[90%] max-sm:mx-auto"
                  />
                </div>
              </div>

            </div>}
          <div className="button text-center mb-2">
            <button className='bg-amber-950 px-7 py-2 text-white text-sm cursor-pointer rounded-md' onClick={submitHandle}>SAVE</button>
          </div>
        </div>

      </div>
    </div>
  )
}
